import { PARTNER_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const PartnerService = {
  getAll: (params: any) => requests.get(`${PARTNER_URL}`, params),
  getSingle: (id: number) => requests.get(`${PARTNER_URL}/${id}`),
  delete: (id: number) => requests.delete(`${PARTNER_URL}/${id}`),
};
